export default {"src":"__ASTRO_ASSET_IMAGE__H6$xwM5n__","width":513,"height":342,"format":"svg"}